// frontend/src/theme/theme.js
import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: '#f2f5f2',
        color: 'gray.800',
      },
    },
  },
  colors: {
    eecf: {
      50: '#e8f5e8',
      100: '#c3e2c3',
      200: '#9ccf9c',
      300: '#75bc75',
      400: '#57ad57',
      500: '#1f7040',
      600: '#1c6038',
      700: '#184f2f',
      800: '#143f26',
      900: '#0f2f1d',
    },
    secondary: {
      50: '#e8fce8',
      100: '#c5f7c5',
      200: '#a0f2a0',
      300: '#7bed7b',
      400: '#5ee95e',
      500: '#2dc653',
      600: '#26b84b',
      700: '#1fa942',
      800: '#189a39',
      900: '#0f7f2a',
    },
  },
  fonts: {
    heading: 'Inter, system-ui, sans-serif',
    body: 'Inter, system-ui, sans-serif',
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: 'eecf',
      },
      baseStyle: {
        fontWeight: '600',
      },
      variants: {
        solid: (props) => ({
          bgGradient: `linear(to-b, ${props.colorScheme}.400, ${props.colorScheme}.600)`,
          color: 'white',
          boxShadow: '0 2px 6px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.25)',
          border: '1px solid',
          borderColor: `${props.colorScheme}.700`,
          _hover: {
            bgGradient: `linear(to-b, ${props.colorScheme}.300, ${props.colorScheme}.500)`,
            boxShadow: '0 4px 10px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.3)',
            transform: 'translateY(-1px)',
            _disabled: {
              bgGradient: `linear(to-b, ${props.colorScheme}.400, ${props.colorScheme}.600)`,
              transform: 'none',
            },
          },
          _active: {
            bgGradient: `linear(to-b, ${props.colorScheme}.500, ${props.colorScheme}.700)`,
            boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.25)',
            transform: 'translateY(0)',
          },
          transition: 'all 0.15s ease',
        }),
      },
    },
    Card: {
      baseStyle: {
        container: {
          borderRadius: 'xl',
          boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 8px 20px -8px rgba(0,0,0,0.12)',
          border: '1px solid',
          borderColor: 'blackAlpha.50',
          transition: 'box-shadow 0.2s ease, transform 0.2s ease',
        },
      },
    },
    Table: {
      variants: {
        striped: {
          tbody: {
            tr: {
              '&:nth-of-type(odd)': {
                td: {
                  background: 'gray.50',
                },
              },
            },
          },
        },
      },
    },
  },
});
